var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/urls.j2"] = require( "macros/urls.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["category/templates/category-more-refinements.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "\n";
output += "\n\n";
env.getTemplate("macros/urls.j2", false, "category/templates/category-more-refinements.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("genericUrl")) {
var t_4 = t_1.genericUrl;
} else {
cb(new Error("cannot import 'genericUrl'")); return;
}
context.setVariable("genericUrl", t_4);
output += "\n\n";
var t_5;
t_5 = (runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "navItem")),"userSelectedShowMore")?(lineno = 5, colno = 19, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["category_see_less_refinements"])):(lineno = 5, colno = 91, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["category_see_more_refinements"])));
frame.set("seeAllText", t_5, true);
if(frame.topLevel) {
context.setVariable("seeAllText", t_5);
}
if(frame.topLevel) {
context.addExport("seeAllText", t_5);
}
output += "\n";
var t_6;
t_6 = (runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "navItem")),"userSelectedShowMore")?"SEE_LESS":"SEE_MORE");
frame.set("facetGroupState", t_6, true);
if(frame.topLevel) {
context.setVariable("facetGroupState", t_6);
}
if(frame.topLevel) {
context.addExport("facetGroupState", t_6);
}
output += "\n\n<div class=\"c-facets__see-all-outer\">\n\t<a href=\"";
output += runtime.suppressValue((lineno = 9, colno = 21, runtime.callWrap(t_4, "genericUrl", context, [runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"catalogRequestPathname"),runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "navItem")),"showMoreQueryString"),runtime.makeKeywordArgs({"excludeContextPath": runtime.contextOrFrameLookup(context, frame, "True")})])), env.opts.autoescape);
output += "\" data-query-string=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "navItem")),"showMoreQueryString"), env.opts.autoescape);
output += "\" class=\"c-facets__see-all-inner js-facets-see-all\" data-facet-name=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "navItem")),"name"), env.opts.autoescape);
output += "\">";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "seeAllText"), env.opts.autoescape);
output += "</a>\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["category/templates/category-more-refinements.j2"] , dependencies)